import { render, staticRenderFns } from "./transformFx.vue?vue&type=template&id=469b58e8&scoped=true"
import script from "./transformFx.vue?vue&type=script&lang=js"
export * from "./transformFx.vue?vue&type=script&lang=js"
import style0 from "./transformFx.vue?vue&type=style&index=0&id=469b58e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b58e8",
  null
  
)

export default component.exports